class HowToSliderV7 {
  constructor(container) {
    this.container = container;
    this.swiper = null;
    this.blurTop = null;
    this.blurBottom = null;
    this.init();
  }

  init() {
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not loaded');
      return;
    }

    this.initSwiper();
    this.initScrollAnimation();
  }

  initSwiper() {
    const swiperElement = this.container.querySelector('.howto-slider-v7__swiper');
    if (!swiperElement) return;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: true,
      scrollbar: {
        el: '.howto-slider-v7__scrollbar',
        draggable: true,
        dragClass: 'swiper-scrollbar-drag',
        hide: false
      },
      breakpoints: {
        991: {
          enabled: false,
          slidesPerView: 4,
          spaceBetween: 12,
          centeredSlides: false
        }
      }
    });
  }

  initScrollAnimation() {
    this.blurTop = this.container.querySelector('.howto-slider-v7__blur--top');
    this.blurBottom = this.container.querySelector('.howto-slider-v7__blur--bottom');

    if (!this.blurTop && !this.blurBottom) return;

    this.handleScroll = this.handleScroll.bind(this);

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: Array.from({ length: 101 }, (_, i) => i / 100)
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.handleScroll();
        } else {
          window.removeEventListener('scroll', this.handleScroll);
        }
      });
    }, observerOptions);

    this.observer.observe(this.container);
  }

  handleScroll() {
    const rect = this.container.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    const totalHeight = rect.height;
    const scrollProgress = Math.max(0, Math.min(1, visibleHeight / totalHeight));

    const scale = 0.6 + (scrollProgress * 0.8);
    const opacity = 0.2 + (scrollProgress * 0.6);
    const translateY = (1 - scrollProgress) * 150;

    if (this.blurTop) {
      this.blurTop.style.transform = `scale(${scale}) translateY(${translateY}px)`;
      this.blurTop.style.opacity = opacity;
    }

    if (this.blurBottom) {
      this.blurBottom.style.transform = `translateX(-50%) scale(${scale}) translateY(${-translateY}px)`;
      this.blurBottom.style.opacity = opacity;
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    if (this.observer) {
      this.observer.disconnect();
    }

    window.removeEventListener('scroll', this.handleScroll);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="howto-slider-v7"]');
  sections.forEach(section => {
    new HowToSliderV7(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-section-type="howto-slider-v7"]')) {
    new HowToSliderV7(event.target);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('[data-section-type="howto-slider-v7"]');
  if (section && section.swiperInstance) {
    section.swiperInstance.destroy();
  }
});
